const initialState = {
    auth: {
        user: null,
        token: null,
        status: null
    },
    loading: false,
    error: null
};

const authReducer = (state = initialState, action) => {
    console.log("Reducer Action:", action);
    console.log("Current State:", state);

    switch (action.type) {
        case "REGISTER":
        case "LOGIN":
            const authData = action.payload;
            // LocalStorage güncellemesi
            if (authData && authData.token) {
                localStorage.setItem("auth", JSON.stringify(authData));
            }

            // State güncellemesi
            const updatedState = {
                ...state,
                auth: {
                    user: authData.user || null,
                    token: authData.token || null,
                    status: authData.status || null
                },
                loading: false,
                error: null
            };


            console.log("Updated State:", updatedState);
            return updatedState;

        case "LOGOUT":
            localStorage.removeItem("auth");
            return {
                ...state,
                auth: {
                    user: null,
                    token: null,
                    status: null
                },
                loading: false,
                error: null
            };

        default:
            return state;
    }
};

export default authReducer;
